// import React from 'react';
import React, { useState,  forwardRef, useContext, useEffect } from 'react';
import ProcessorList from './Management/processorlist';
import AdminList from './Management/adminlist';
import ExpertList from './Management/expertlist';
import GCodeList from './Management/gcodelist';
import ManufacturerList from './Management/manufacturerlist';
import PartnerList from './Management/partnerlist';
import ManuLocation from './Management/manuLocation';
import { AuthorizeContext } from "../RootContext";


const UserManagePage = () => {
   const { token, authBody, setAuthenticated, setAuthBody } = useContext(AuthorizeContext);
  const [data, setData] = useState({});
  // let { hospitalID } = useParams();

  const [profile, setProfile] = useState(authBody || {role: "visitor"})
  const hasRole = (profile, roles) =>{
    return roles.includes(profile.role)
  }
  console.log(profile)

// const canManu = (profile, can) =>{
//     return can.includes(profile.role)
//   }
//   useEffect(() => {
//     const fetchData = async () => {
//       const res = await axios({
//         url: `https://${api_url}/api/internal_user_management?Role=partner_admin`,
//         method: 'get',
//         headers: {
//           'x-access-token' : token
//         }
//       }).then(res=> {
//         if(res.data.message){
//           alert(res.data.message)
//         }
//         else if(res.data.validation){
//           alert(res.data.validation.replace("_", " "))
//         }
//         else if(res.data.notLoggedIn){
//           setAuthenticated(false)
//           setAuthBody({role: 'visitor'})
//           alert("You have been logged out due to inactivity. Please log in again.")
//         }
//         else{
//           setLoading(false)
//           setState((prevState) => ({
//             ...prevState, data: res.data
//           }))
//         }
//       });


//     };

//     fetchData();
//   }, []);
  return(
    <>    
    {
      hasRole(profile, ['super_admin', 'write_admin', 'read_admin']) && 
      <div>
    <ProcessorList />
    <ExpertList />
    <GCodeList />
    <PartnerList/>
    <AdminList />
    <ManufacturerList />
    <ManuLocation/>
      </div>
    }
    {
      hasRole(profile, ['partner_admin']) && profile.manu_given === true ?
      <div>
    <ManufacturerList />
      </div>
      :
      <div></div>
    }
    </>
  )
};

export default UserManagePage;
